import { register } from "@rill/loader";

/**
 * Compliance for one Flexible Program: every occurrence window in range, what
 * the coach programmed, and what the client actually did.
 *
 * Occurrence windows are derived server-side rather than stored, so a week the
 * client skipped entirely still comes back as 0 of N - which is what the
 * History tab has to show. Ask for a range that reaches past today so the
 * Upcoming tab has rows too.
 */
register(
  {
    name: "flexibleProgramOverview",
    meta: ["cycle", "exercise"],
    ttl: "2 hours",
  },
  async ({ api }, { cycleId, from, to }) => {
    return await api("flexible-program-overview", {
      query: {
        cycleId,
        ...(from ? { from } : {}),
        ...(to ? { to } : {}),
      },
    }).then(async (response) => {
      return await response.json();
    });
  }
);
